import * as Yup from 'yup';

export const Validation = {
  phone(message = 'Некорректно указан телефон') {
    return Yup.string().matches(
      /^((8|\+7)[- ]?)?(\(?\d{3}\)?[- ]?)?[\d\- ]{7,10}$/,
      {
        message,
      },
    );
  },
  email(message = 'Некорректно указан Email') {
    return Yup.string().email(message);
  },
  cyrillic(message = 'Введите кириллицей') {
    return Yup.string().matches(/^([а-яА-ЯЁё]\s?)+$/, message);
  },
  name(message = 'В имени не должно быть цифр') {
    return Yup.string().matches(/^([^0-9]*)$/, message);
  },
  privacy(message = 'Необходимо принять условия пользовательского соглашения') {
    return Yup.bool().oneOf([true], message);
  },
  policy(message = 'Необходимо принять правила участия в программе') {
    return Yup.bool().oneOf([true], message);
  },
  array(amount = 1, message?: string) {
    return Yup.array().min(amount, message);
  },
  required(
    schema: Yup.StringSchema | Yup.BooleanSchema = Yup.string(),
    message = 'Обязательное поле',
  ) {
    return schema.required(message);
  },
  pid(message = 'Неверный офрмат') {
    return Yup.string().matches(/^(mcs[0-9]{10})$/, {
      message,
    });
  },
};
